var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApplyCouponGraphic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 172.171,
    height: 48.052,
    viewBox: "0 0 172.171 48.052",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6421",
    "data-name": "Group 6421",
    transform: "translate(-73.4 -132.448)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_703",
    "data-name": "Ellipse 703",
    cx: 3.671,
    cy: 3.671,
    r: 3.671,
    transform: "translate(238.228 173.157)",
    fill: "#ff6584",
    opacity: 0.27
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6405",
    "data-name": "Group 6405",
    transform: "matrix(0.574, -0.819, 0.819, 0.574, 73.4, 163.133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3605",
    "data-name": "Path 3605",
    d: "M7.63,0C4.126.221,0,4.853,0,4.853L3.979,8.37a11.349,11.349,0,0,1,7.927-4.664",
    transform: "translate(0 0)",
    fill: "#c6f3e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3606",
    "data-name": "Path 3606",
    d: "M2.94,2.907,0,0",
    transform: "translate(8.965 0)",
    fill: "#c6f3e9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6412",
    "data-name": "Group 6412",
    transform: "translate(4690.673 -3615.664)",
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3605-2",
    "data-name": "Path 3605",
    d: "M-4502.483,3755.164c-2.424-.173-5.278-3.8-5.278-3.8l2.752-2.752a7.874,7.874,0,0,0,5.483,3.65",
    fill: "#febc20",
    stroke: "#febc20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3606-2",
    "data-name": "Path 3606",
    d: "M-4489.394,3759.094l-2.94,2.907",
    transform: "translate(-10.132 -6.837)",
    fill: "#febc20",
    stroke: "#febc20",
    strokeLinecap: "round",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplyCouponGraphic);
export default __webpack_public_path__ + "static/media/Apply_coupon_ graphic.c98f780d884d35fe415368ce5aaffb2a.svg";
export { ForwardRef as ReactComponent };